document.addEventListener('DOMContentLoaded', function () {
    const indicators = document.querySelectorAll('.indicator');
    const pauseButton = document.getElementById('pauseButton');
    const items = document.querySelectorAll('.hero-carousel-item');
    let currentIndex = 0;
    let interval;
    let isPaused = false;
    let intervalDuration = 5000;

    function loadImage(img) {
        return new Promise(resolve => {
            if (img.complete) {
                resolve();
            } else {
                img.onload = resolve;
                img.onerror = resolve;
                img.src = img.dataset.src;
                img.srcset = img.dataset.srcset;
            }
        });
    }

    function preloadImages() {
        const promises = Array.from(items).map(item => {
            const img = item.querySelector('img');
            return loadImage(img);
        });

        return Promise.all(promises);
    }

    function showSlide(index) {
        items.forEach((item, i) => {
            if (i === index) {
                item.style.zIndex = '10';
                item.style.position = 'relative';
                item.style.opacity = '1';
                item.style.transition = 'opacity 1s ease-in-out';
                item.setAttribute('aria-hidden', 'false');
                item.setAttribute('tabindex', '0');
            } else {
                item.style.zIndex = '-1';
                item.style.position = 'absolute';
                item.style.opacity = '0';
                item.style.transition = 'opacity 1s ease-in-out';
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
        if (isPaused) return;
        updateIndicators(index);
    }

    function updateIndicators(index) {
        indicators.forEach((indicator, i) => {
            if (i === index) {
                indicator.classList.add('active-indicator');
                startLoading(indicator);
            } else {
                indicator.classList.remove('active-indicator');
                stopLoading(indicator);
            }
        });
    }

    function startLoading(indicator) {
        const loadingBar = indicator.querySelector('.loading-bar');
        loadingBar.style.width = '100%';
        loadingBar.style.transition = `width ${intervalDuration}ms linear`;
    }

    function stopLoading(indicator) {
        const loadingBar = indicator.querySelector('.loading-bar');
        loadingBar.style.width = '0';
        loadingBar.style.transition = 'none';
    }

    function startCarousel() {
        interval = setInterval(() => {
            currentIndex = (currentIndex + 1) % items.length;
            showSlide(currentIndex);
        }, intervalDuration);
    }

    function resetCarousel() {
        clearInterval(interval);
        startCarousel();
    }

    indicators.forEach(indicator => {
        indicator.addEventListener('click', function () {
            currentIndex = parseInt(this.dataset.index);
            showSlide(currentIndex);
            if (isPaused) return;
            resetCarousel();
        });
    });

    if (pauseButton) {
        pauseButton.addEventListener('click', function () {
            const icon = pauseButton.querySelector('svg');

            if (isPaused) {
                startCarousel();
                icon.dataset.lucide = 'pause';
                pauseButton.setAttribute("aria-label", "Play")
                const currentIndicator = indicators[currentIndex];
                currentIndicator.classList.add('active-indicator');
                startLoading(currentIndicator);
            } else {
                clearInterval(interval);
                icon.dataset.lucide = 'play';
                pauseButton.setAttribute("aria-label", "Pause")
                indicators.forEach(indicator => {
                    indicator.classList.remove('active-indicator');
                    stopLoading(indicator);
                });
            }
            lucide.createIcons();
            isPaused = !isPaused;
        });
    }

    preloadImages().then(() => {
        showSlide(currentIndex);
        startCarousel();
    }).catch((error) => {
        console.error('Error preloading images:', error);
    });
});
